import { ActionFlagsModel } from "../model/actionFlags";

export const ReadFlags = (flags: ActionFlagsModel[], flag: string) => {
  //console.log(flags)
  return flags.find((f) => f.name === flag)?.value;
};
